import React from 'react';
import { Link } from 'react-router-dom';
import jobIcon from '../../Assets/images/dashboard/jobIcon.svg';
import ButtonComponent from '../../Components/common/buttons/ButtonComponent/ButtonComponent';
import { buttonVariants } from '../../Components/common/buttons/types';
import PercentageCircle from '../../Components/common/PercentageCircle/PercentageCircle';
import timesheetIcon from '../../Assets/images/dashboard/timesheetIcon.svg';
import expenseIcon from '../../Assets/images/dashboard/expenseIcon.svg';
import { NotificationCard } from '../../Components/common/Cards/NotificationCard/NotificationCard';
import TimeandExpenseCard from '../../Components/common/Cards/TimeandExpenseCard/TimeandExpenseCard';
import onboardingIcon from '../../Assets/images/dashboard/onboardingIcon.svg';
import { generalEnums } from '../../utils/enums';
import AddGradientIcon from '../../Components/common/Icons/AddGradientIcon';
import { useWindowSize } from '../../utils/hooks';

const CreateButton = ({ link }) => {
  const { width } = useWindowSize();

  return (
    <Link to={link}>
      <AddGradientIcon size={width > 768 ? '42px' : '24px'} />
    </Link>
  );
};

const contractorConfig = ({
  t,
  navigate,
  setSearchField,
  searchField,
  accessTo,
  timesheetValidationStatus,
  expenseValidationStatus,
  timesheetCountsContractor,
  expensesCountsContractor,
  validationPending
}) => {
  const handleProfileContinue = () => {
    navigate('/my-profile');
  };

  const handleSearchJobs = () => {
    navigate({
      pathname: '/dashboard/jobs',
      search: `&field=${searchField}`
    });
  };

  return [
    {
      id: 'onboarding',
      order: 1,
      icon: onboardingIcon,
      title: t('dashboard.cards.onboarding'),
      isDualLayout: true,
      isCustom: false,
      leftContent: null,
      clickAction: '/dashboard/tifo',
      child: (styles) => (
        <div className={styles.profileWrapper}>
          <h5>{t('dashboard.cards.getreadyfirstday')}</h5>
          <button className={styles.continueButton}>{t('common.general.continue')}</button>
        </div>
      )
    },
    // {
    //   id: 'jobmatches',
    //   order: accessTo.onboarding ? 3 : 2,
    //   icon: jobIcon,
    //   title: t('dashboard.cards.jobmatches'),
    //   isDualLayout: true,
    //   isCustom: false,
    //   leftContent: null,
    //   child: () => (
    //     <>
    //       <ButtonComponent variant={buttonVariants.ROUNDED} text={t('dashboard.cards.updatepref')} />
    //       <ButtonComponent variant={buttonVariants.ROUNDED} text={t('dashboard.cards.seejobmatch')} />
    //     </>
    //   )
    // },
    {
      id: 'jobs',
      order: accessTo.onboarding ? 4 : 3,
      icon: null,
      title: 'Jobs',
      isDualLayout: false,
      isCustom: false,
      leftContent: null,
      child: (styles) => (
        <>
          <h5>{t('dashboard.cards.searchrole')}</h5>
          <input
            onChange={(e) => setSearchField(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearchJobs();
            }}
            type="text"
            placeholder="Keyword eg: Engineer"
            className={styles.searchInput}
          />
          <Link to={`/dashboard/jobs?field=${searchField}`}>
            <ButtonComponent variant={buttonVariants.ROUNDED} text={t('dashboard.cards.searchjobs')} />
          </Link>
        </>
      )
    },
    {
      id: 'profile',
      order: accessTo.onboarding ? 2 : 4,
      icon: null,
      title: t('dashboard.cards.myprofile'),
      isDualLayout: true,
      isCustom: true,
      clickAction: '/my-profile',
      leftContent: <PercentageCircle percentage={100} />,
      child: (styles) => (
        <div className={styles.profileWrapper}>
          <h5>{t('dashboard.cards.profileuptodate')}</h5>
          <button onClick={handleProfileContinue} className={styles.continueButton}>
            {t('common.general.continue')}
          </button>
        </div>
      )
    },
    {
      id: 'notification',
      order: 5,
      icon: null,
      title: t('dashboard.cards.notifications'),
      isDualLayout: false,
      isCustom: false,
      leftContent: null,
      child: () => <NotificationCard />
    },
    {
      id: 'timesheet',
      order: 6,
      icon: timesheetIcon,
      title: t('dashboard.cards.timesheets'),
      isDualLayout: true,
      clickAction: '/dashboard/timesheets',
      isCustom: false,
      leftContent: null,
      extraComponent: timesheetValidationStatus && <CreateButton link="/dashboard/create-timesheet" />,
      child: (styles) => (
        <TimeandExpenseCard
          type={generalEnums.TIMESHEET}
          styles={styles}
          status={timesheetValidationStatus}
          pending={validationPending}
          list={timesheetCountsContractor}
        />
      )
    },
    {
      id: 'expense',
      order: 7,
      icon: expenseIcon,
      title: t('dashboard.cards.expenses'),
      isDualLayout: true,
      isCustom: false,
      leftContent: null,
      clickAction: '/dashboard/expenses',
      extraComponent: expenseValidationStatus && <CreateButton link="/dashboard/create-claim" />,
      child: (styles) => (
        <TimeandExpenseCard
          type={generalEnums.EXPENSE}
          styles={styles}
          status={expenseValidationStatus}
          pending={validationPending}
          list={expensesCountsContractor}
        />
      )
    }
  ];
};

const approverConfig = ({
  t,
  navigate,
  setSearchField,
  searchField,
  timesheetValidationStatus,
  expenseValidationStatus,
  validationPending,
  pendingTandECounts
}) => {
  const handleSearchJobs = () => {
    navigate({
      pathname: '/dashboard/jobs',
      search: `&field=${searchField}`
    });
  };

  return [
    {
      id: 'timesheet',
      order: 1,
      icon: timesheetIcon,
      title: t('dashboard.cards.timesheets'),
      isDualLayout: true,
      isCustom: false,
      leftContent: null,
      clickAction: '/dashboard/timesheets',
      child: (styles) => (
        <TimeandExpenseCard
          type={generalEnums.TIMESHEET}
          styles={styles}
          status={timesheetValidationStatus}
          pending={validationPending}
          list={pendingTandECounts?.PendingTimesheetCount}
        />
      )
    },
    {
      id: 'expense',
      order: 2,
      icon: expenseIcon,
      title: t('dashboard.cards.expenses'),
      isDualLayout: true,
      isCustom: false,
      leftContent: null,
      clickAction: '/dashboard/expenses',
      child: (styles) => (
        <TimeandExpenseCard
          type={generalEnums.EXPENSE}
          styles={styles}
          status={expenseValidationStatus}
          pending={validationPending}
          list={pendingTandECounts?.PendingClaimsCount}
        />
      )
    }
    // {
    //   id: 'contractor',
    //   order: 3,
    //   icon: null,
    //   title: 'Contractors',
    //   isDualLayout: false,
    //   isCustom: false,
    //   leftContent: null,
    //   child: (styles) => (
    //     <>
    //       <h5>Contractor search</h5>
    //       <input
    //         onChange={(e) => setSearchField(e.target.value)}
    //         onKeyDown={(e) => {
    //           if (e.key === 'Enter') handleSearchJobs();
    //         }}
    //         type="text"
    //         placeholder="Mary Smith"
    //         className={styles.searchInput}
    //       />
    //       <ButtonComponent
    //         variant={buttonVariants.ROUNDED}
    //         text={t('dashboard.cards.searchjobs')}
    //         action={handleSearchJobs}
    //         classes={styles.fullWidthButton}
    //       />
    //     </>
    //   )
    // },
    // {
    //   id: 'notification',
    //   order: 4,
    //   icon: null,
    //   title: t('dashboard.cards.notifications'),
    //   isDualLayout: false,
    //   isCustom: false,
    //   leftContent: null,
    //   child: () => <h5>{t('dashboard.cards.nonewnotification')}</h5>
    // }
  ];
};

export { contractorConfig, approverConfig };
